import { CommonTopMenuItem, faqItemType } from "./CommonTopMenuItem";
import classes from "./CommonTopMenu.module.scss";

type Props = {
  items: faqItemType[];
};

export const CommonTopMenu = ({ items }: Props) => {
  return (
    <div className={classes["top-view-menu"]}>
      <ul className={classes["menu"]}>
        {items.map((item, index) => (
          <CommonTopMenuItem key={index} item={item} />
        ))}
      </ul>
    </div>
  );
};

export type { faqItemType };
